import React, { Component } from 'react';

import Helmet from './Helmet';

const Title = 'Product Changelog Software and Release Notes Tool | Canny';
const Description =
  'Share product updates with your users with our product changelog software and release note tools. Get started for free and set up in minutes.';
const Image = 'https://canny.io/images/canny-changelog-helmet.jpg';

export default class LandingChangelogHelmet extends Component {
  render() {
    return (
      <Helmet
        title={Title}
        meta={[
          { name: 'description', content: Description },

          { property: 'og:image', content: Image },
          { property: 'og:title', content: Title },
          { property: 'og:description', content: Description },
          { property: 'og:url', content: 'https://canny.io/features/product-changelog' },
          { property: 'og:type', content: 'website' },

          { name: 'twitter:card', content: 'summary_large_image' },
          { name: 'twitter:site', content: '@cannyHQ' },
          { name: 'twitter:title', content: Title },
          { name: 'twitter:description', content: Description },
          { name: 'twitter:image', content: Image },
        ]}
      />
    );
  }
}
